/** Pure inbound buyer-cancellation classification. No provider I/O. */

function asText(value: unknown): string {
  if (value == null) return "";
  if (typeof value === "string" || typeof value === "number") return String(value).trim();
  return "";
}

const ACTIONABLE_REQUEST_STATES = new Set([
  "CANCEL_REQUESTED",
  "IN_PROGRESS",
  "REQUESTED",
  "PENDING",
]);

const COMPLETED_STATES = new Set([
  "CANCEL_CLOSED_WITH_REFUND",
  "CANCEL_CLOSED_NO_REFUND",
  "CANCEL_CLOSED",
  "COMPLETED",
  "CLOSED",
  "CANCELED",
  "CANCELLED",
  "CLOSED_SUCCESS",
  "CLOSED_FAILURE",
]);

export function ebayInboundCancelInitiatorIsBuyer(initiator: unknown): boolean {
  return asText(initiator).toUpperCase() === "BUYER";
}

export function ebayInboundCancelIsCompleted(opts: {
  requestState?: unknown;
  orderCancelState?: unknown;
}): boolean {
  const req = asText(opts.requestState).toUpperCase();
  const order = asText(opts.orderCancelState).toUpperCase();
  return COMPLETED_STATES.has(req) || COMPLETED_STATES.has(order);
}

export function ebayInboundCancelIsActionableBuyer(opts: {
  initiator?: unknown;
  requestState?: unknown;
  orderCancelState?: unknown;
}): boolean {
  if (!ebayInboundCancelInitiatorIsBuyer(opts.initiator)) return false;
  if (ebayInboundCancelIsCompleted(opts)) return false;
  const req = asText(opts.requestState).toUpperCase();
  const order = asText(opts.orderCancelState).toUpperCase();
  return ACTIONABLE_REQUEST_STATES.has(req) || order === "IN_PROGRESS";
}
